export default __webpack_public_path__ + "static/media/physicalized_interface_hidef.2442b1f2.PNG";